import React from "react";
import { Table, Tag, Row, Col } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

const AssetAssignmentTable = ({ assignmentsDependenciesToControls, assets }) => {
  // Función para generar los datos de la tabla agrupados por Activo y Control
  const generateTableData = () => {
    const data = [];

    // Recorrer todos los activos
    assets.forEach((asset) => {
      // Recorrer todos los controles del activo
      asset.controls.forEach((control) => {
        // Obtener las dependencias asignadas para este control
        const dependencies = assignmentsDependenciesToControls[asset.key]?.[control.key] || {};

        // Obtener las dependencias iniciales (desde el backend) del control
        const initialDependencies = control.dependencies.reduce((acc, dep) => {
          acc[dep.code] = dep.flag;
          return acc;
        }, {});

        // Filtrar las dependencias que han cambiado
        const changedDependencies = Object.keys(dependencies)
          .filter((depCode) => dependencies[depCode] !== initialDependencies[depCode])
          .map((depCode) => {
            const dependency = control.dependencies.find((d) => d.code === depCode);
            return {
              name: dependency.name,
              status: dependencies[depCode] ? "Activo" : "Inactivo",
              description: dependency.description
            };
          });

        // Si hay dependencias modificadas, agregar una fila a la tabla
        if (changedDependencies.length > 0) {
          data.push({
            key: `${asset.key}-${control.key}`,
            asset: asset.title,
            control: control.title,
            dependencies: changedDependencies,
          });
        }
      });
    });

    return data;
  };

  // Columnas de la tabla
  const columns = [
    {
      title: "Control",
      dataIndex: "control",
      key: "control",
      sorter: (a, b) => a.control.localeCompare(b.control),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      align: 'center',
      width: '20%',
    },
    {
      title: "Activo",
      dataIndex: "asset",
      key: "asset",
      sorter: (a, b) => a.asset.localeCompare(b.asset),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      align: 'center',
      width: '15%',
    },
    {
      title: "Dependencias Asignadas",
      dataIndex: "dependencies",
      key: "dependencies",
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', textAlign: 'center' } }),
      width: '65%',
      render: (dependencies) => (
        <Row gutter={[8, 8]} style={{ marginLeft: 0, marginRight: 0 }}>
          {dependencies.map((dependency, index) => (
            <Col key={index} span={24}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "4px 8px",
                  backgroundColor: dependency.status === "Activo" ? "#f6ffed" : "#fff2f0",
                  borderRadius: "4px",
                  border: `1px solid ${dependency.status === "Activo" ? "#b7eb8f" : "#ffccc7"}`,
                }}
              >
                {dependency.status === "Activo" ? (
                  <>
                    <CheckCircleOutlined style={{ color: "#52c41a" }} />
                    <span style={{ fontWeight: "bold", color: "#52c41a" }}>Asignado</span>
                  </>
                ) : (
                  <>
                    <CloseCircleOutlined style={{ color: "#ff4d4f" }} />
                    <span style={{ fontWeight: "bold", color: "#ff4d4f" }}>Desasignado</span>
                  </>
                )}
                <div>
                  <div style={{ fontWeight: 500 }}>{dependency.name}</div>
                  <div style={{ fontSize: 12, color: "#666" }}>{dependency.description}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ),
    },
  ];

  // Datos de la tabla (agrupados por Activo y Control)
  const tableData = generateTableData();

  return (
    <Col span={24}>
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={false}
        scroll={{ y: 450 }}
        style={{ minHeight: 224 }}
        rowKey="key"
      />
    </Col>
  );
};

export default AssetAssignmentTable;